/*
 * Popup window container component
 * Author: Chris
 * CreatedAt: 2021-4-1
 */

import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { LineCollapse } from '@/src/components';
// import { getTimezone } from '@/src/constrains/GlobalProvider/slice';
import TimerPickerModal from '@/src/pages/SalesChannelContentEditor/Components/TimePickerModal';
import {
  getOccupiedRanges,
  getPopUpWindowData,
  onAddNewCollapseItem,
  onCollapseOpen,
  onSettingPopUpDate,
  onSettingPopUpFrequency,
  onSettingPopUpImage,
  onSettingPopUpLink,
  onSettingPopUpRemark,
  onSettingPopUpType,
  onShiftEditingItem,
  onShiftItems,
} from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/redux';
import { randomNumber } from '@/src/tools/helper';
import { IPopUpWindow } from '@/src/types/common/SalesChannel';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, handleOnGetCurrentSCTimezoneUTC } from 'src/tools/tools';
import { getPopUpWindowDataById } from '../common';
import CollapseItem from './CollapseItem/CollapseItem';
import css from './PopUpWindow.less';
const PopUpWindow = (props: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const scTimezoneUTC = handleOnGetCurrentSCTimezoneUTC();
  const isPrimary = useSelector(isPrimaryLanguage());
  const _d = useDispatch();
  // const timeZone = useSelector(getTimezone());
  const occupiedRange = useSelector(getOccupiedRanges());
  const popUpWindowData = useSelector(getPopUpWindowData());

  const [group, setGroup] = useState<string[]>([
    'InUse',
    'Pending',
    'Previous',
  ]);

  const [showEditWindow, setShowEditWindow] = useState(false);
  const [activeId, setActiveId] = useState('');
  const [timeVisible, setTimeVisible] = useState(false);
  const [date, setDate] = useState({
    startTime: '',
    endTime: '',
  });

  useEffect(() => {
    const count = Object.keys(popUpWindowData.editing).length;
    setShowEditWindow(Boolean(count));
  }, [popUpWindowData]);

  const handleAddNewPopUp = () => {
    if (popUpWindowData.editing.id) {
      _d(onShiftEditingItem({ id: popUpWindowData.editing.id }));
    }

    const id = randomNumber();
    _d(onAddNewCollapseItem({ id }));
    _d(onCollapseOpen({ idArr: [id] }));
    setShowEditWindow(true);
  };

  const handleChangeCollapseItem = (type: string, data: IPopUpWindow) => {
    const { id } = data;
    setActiveId(id);

    if (type === 'remark') {
      _d(onSettingPopUpRemark({ ...data }));
    } else if (type === 'date') {
      setTimeVisible(true);
      const targetPopUpWindowData = getPopUpWindowDataById(popUpWindowData, id);
      const { beginDate, endDate, beginTime, endTime } = targetPopUpWindowData;
      if (Boolean(beginTime) && Boolean(beginDate)) {
        let endDNT;
        if (!Boolean(endDate) || !Boolean(endTime)) {
          endDNT = null;
        } else {
          endDNT = `${endDate} ${endTime}`;
        }

        setDate({
          startTime: moment(`${beginDate} ${beginTime}`).format(
            'DD MMM YY, HH:mm',
          ),
          endTime: endDNT ? moment(endDNT).format('DD MMM YY, HH:mm') : null,
        });
      } else {
        setDate({ startTime: '', endTime: '' });
      }
    } else if (type === 'radio') {
      _d(onSettingPopUpType({ ...data }));
    } else if (type === 'image') {
      _d(onSettingPopUpImage({ ...data }));
    } else if (type === 'link') {
      _d(onSettingPopUpLink({ ...data }));
    } else if (type === 'frequency') {
      _d(onSettingPopUpFrequency({ ...data }));
    }
  };

  const handleOpenCollapse = (status: boolean, id: string) => {
    if (!status) {
      _d(onShiftItems({ data: {} }));
    } else {
      setActiveId(id);
    }
  };

  const handleOpenLineCollapse = (keys: string[]) => {
    setGroup(keys);
  };

  const handleCloseTimerModal = () => {
    setTimeVisible(false);
  };

  const handleSubmitTimeModal = (start, end) => {
    setTimeVisible(false);
    if (Boolean(start)) {
      const beginDate = start ? moment(start).format('YYYY-MM-DD') : '';
      const beginTime = start ? moment(start).format('HH:mm') : '';

      if (!Boolean(end)) {
        end = null;
      }
      const endDate = end ? moment(end).format('YYYY-MM-DD') : '';
      const endTime = end ? moment(end).format('HH:mm') : '';
      _d(
        onSettingPopUpDate({
          id: activeId,
          date: { beginDate, beginTime, endDate, endTime },
        }),
      );
      setDate({
        startTime: moment(`${beginDate} ${beginTime}`).format(
          'DD MMM YY, HH:mm',
        ),
        endTime:
          endDate && endTime
            ? moment(`${endDate} ${endTime}`).format('DD MMM YY, HH:mm')
            : null,
      });
    } else {
      _d(
        onSettingPopUpDate({
          id: activeId,
          date: { beginDate: '', beginTime: '', endDate: '', endTime: '' },
        }),
      );
      setDate({ startTime: '', endTime: '' });
    }
  };

  const resetTimeModal = () => void 0;

  const renderCollapseItem = (
    item: IPopUpWindow,
    editable: boolean,
    shouldShowErrors: boolean,
    scTimezoneUTC: string,
  ) => {
    return (
      <CollapseItem
        withoutCollapse={props.withoutCollapse}
        isPrimary={isPrimary}
        shouldShowErrors={shouldShowErrors}
        editable={editable}
        key={item.id}
        linkSet={props.linkSet}
        data={item}
        onChange={(t, v) => handleChangeCollapseItem(t, v)}
        onOpenCollapse={(s) => handleOpenCollapse(s, item.id)}
        scTimezoneUTC={scTimezoneUTC}
      />
    );
  };

  const List = [
    {
      headerText: getI18n('general.status.active'),
      key: 'InUse',
      content: popUpWindowData.inUse.map((item) => {
        return renderCollapseItem(item, true, true, scTimezoneUTC);
      }),
    },
    {
      headerText: getI18n('general.paymentStatus.pending'),
      key: 'Pending',
      content: popUpWindowData.pending.map((item) => {
        return renderCollapseItem(item, true, true, scTimezoneUTC);
      }),
    },
    {
      headerText: getI18n('salesChannelContent.index.previous'),
      key: 'Previous',
      content: popUpWindowData.previous.map((item) => {
        return renderCollapseItem(item, false, false, scTimezoneUTC);
      }),
    },
  ];

  return (
    <>
      <section className={css.container}>
        <div className={css.title}>
          {getI18n('salesChannelContent.index.popupWindowPromotion')}
        </div>
        <div className={css.timeZone}>
          {`${getI18n('general.timeZone')} (UTC${scTimezoneUTC})`}
        </div>
        {isPrimary && (
          <div className={css.addNewButton} onClick={handleAddNewPopUp}>
            + {getI18n('salesChannelContent.index.newPopupWindowPromotion')}
          </div>
        )}
      </section>

      <section className={css.editing}>
        {showEditWindow && isPrimary && (
          <CollapseItem
            withoutCollapse={props.withoutCollapse}
            isPrimary={isPrimary}
            shouldShowErrors={false}
            editable={true}
            linkSet={props.linkSet}
            data={popUpWindowData.editing}
            onChange={(t, v) => handleChangeCollapseItem(t, v)}
            onOpenCollapse={(s) =>
              handleOpenCollapse(s, popUpWindowData.editing.id)
            }
            scTimezoneUTC={scTimezoneUTC}
          />
        )}
      </section>
      <section className={css.lineCollapse}>
        <LineCollapse
          data={List}
          open={group}
          setOpen={handleOpenLineCollapse}
        />
      </section>
      <TimerPickerModal
        // title={'Edit Popup Window Promotion Time'}
        visible={timeVisible}
        onCancel={handleCloseTimerModal}
        onSubmit={handleSubmitTimeModal}
        afterClose={resetTimeModal}
        occupiedRanges={occupiedRange}
        timezoneGmt={`UTC ${scTimezoneUTC}`}
        date={date}
      />
    </>
  );
};

export default PopUpWindow;
